/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMehrarbeitUmbuchungDto } from '../../models/create-mehrarbeit-umbuchung-dto';
import { MehrarbeitUmbuchungDto } from '../../models/mehrarbeit-umbuchung-dto';

export interface CreateMehrarbeitUmbuchung$Json$Params {
  
    /**
     * Daten der Mehrarbeit Umbuchung
     */
    body?: CreateMehrarbeitUmbuchungDto
}

export function createMehrarbeitUmbuchung$Json(http: HttpClient, rootUrl: string, params?: CreateMehrarbeitUmbuchung$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MehrarbeitUmbuchungDto>> {
  const rb = new RequestBuilder(rootUrl, createMehrarbeitUmbuchung$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MehrarbeitUmbuchungDto>;
    })
  );
}

createMehrarbeitUmbuchung$Json.PATH = '/v1/mehrarbeitumbuchung/create';
